import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const AnnouncementDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { announcement } = location.state || {};

  // If no announcement data, show error
  if (!announcement) {
    return (
      <div className="container-fluid p-4">
        <div className="row">
          <div className="col-12">
            <div className="alert alert-danger">
              Announcement not found. Please go back to the dashboard.
            </div>
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/dashboard')}
            >
              Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }

  const hasImage = announcement.hasImage && announcement.imageUrl;

  return (
    <div className="container-fluid p-0" style={{ background: "#f8f9fa", minHeight: "100vh" }}>
      {/* Header */}
      <div className="bg-white shadow-sm py-3">
        <div className="container">
          <div className="row align-items-center">
            <div className="col">
              <button 
                className="btn btn-outline-secondary"
                onClick={() => navigate(-1)}
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "1.1rem",
                  fontWeight: 500
                }}
              >
                ← Back
              </button>
            </div>
            <div className="col text-center">
              <h1 className="h3 mb-0" style={{ fontWeight: 700 }}>Announcement Details</h1>
            </div>
            <div className="col"></div>
          </div>
        </div>
      </div>

      {/* Announcement Content */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10 col-xl-8">
            <div className="bg-white rounded-4 shadow-sm p-4 p-md-5">
              {/* Title and Date */}
              <div className="mb-4 pb-3 border-bottom">
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <h1
                    className="display-5 fw-bold"
                    style={{ color: "#222", lineHeight: 1.2 }}
                  >
                    {announcement.title}
                  </h1>
                  <span
                    className="text-muted fs-5"
                    style={{ fontWeight: 500, whiteSpace: "nowrap", marginLeft: "2rem" }}
                  >
                    {announcement.date}
                  </span>
                </div>
              </div>

              {/* Image (if available) */}
              {hasImage && (
                <div className="mb-5">
                  <div className="announcement-detail-image-container rounded-3 overflow-hidden">
                    <img
                      src={announcement.imageUrl}
                      alt="Announcement"
                      className="img-fluid w-100"
                      style={{ 
                        maxHeight: "500px", 
                        objectFit: "cover" 
                      }}
                    />
                  </div>
                </div>
              )}

              {/* Full Content */}
              <div className="announcement-full-content">
                <div
                  className="fs-5 lh-base"
                  style={{ color: "#444", lineHeight: 1.8 }}
                >
                  {announcement.fullContent || announcement.content}
                </div>
              </div>

              {/* Additional Details */}
              {(announcement.author || announcement.category) && (
                <div className="mt-5 pt-4 border-top">
                  <div className="row">
                    {announcement.author && (
                      <div className="col-12 col-sm-6 mb-3">
                        <strong className="text-muted">Author:</strong>
                        <span className="ms-2" style={{ color: "#666" }}>
                          {announcement.author}
                        </span>
                      </div>
                    )}
                    {announcement.category && (
                      <div className="col-12 col-sm-6 mb-3">
                        <strong className="text-muted">Category:</strong>
                        <span className="ms-2" style={{ color: "#666" }}>
                          {announcement.category}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Action Buttons */}
              <div className="mt-5 pt-3 d-flex gap-3">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementDetail;